import { render, staticRenderFns } from "./Antennas.vue?vue&type=template&id=cc3f0312&scoped=true&"
import script from "./Antennas.vue?vue&type=script&lang=js&"
export * from "./Antennas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc3f0312",
  null
  
)

export default component.exports